module.exports = __webpack_public_path__ + "img/login_bg2.1899378f.jpg";